<div class="page-body" >
  <div class="row">
    <div class="col-sm-12">
      <app-card [title]="'global.overview'|translate"
                [cardOptionBtnIcon]="'fa fa-repeat'"
                [cardOptionBtn]="false"
                [advanceButton]="true"
                (outputButtonAdvance)="calFunction($event)"
      >
        <app-grid [buttonViewChange]="true"  [grid]="grid"  (sendParameters)="setParams($event)"></app-grid>
      </app-card>
    </div>
  </div>
</div>
<a #downloadLink href="" download style="display: none"></a>
<ng-template #expectedDeliveryWeekTemp let-row="row" let-value="value" let-column="column">
  {{row.expectedDeliveryWeek ? (row.expectedDeliveryWeek|WeekDateFormat) : ''}}
</ng-template>
<app-modal-basic #cancelModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.cancel_quote' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="cancelModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.cancel_quote_body' | translate}}: <b [innerHTML]="quoteReference"></b></p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="cancelModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="cancelQuote()">{{'global.yes'|translate}}</button>
  </div>
</app-modal-basic>


<app-modal-basic #assignDealerModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.assign_quote' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="assignDealerModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #addCreateCustomInvoiceForm="ngForm">
        <p>{{'admin.order.custom_invoice.modal.choose-dealer' | translate}}</p>
        <div class="form-group row">
          <div class="form-group form-default form-static-label col-12">
            <ng-select #dealerSelect="ngModel"
                 name="dealer"
                 [items]="dealers"
                 [required]="true"
                 [(ngModel)]="selectedDealer"
                 bindLabel="companyName"
                 bindValue="id"
                 placeholder="{{ 'global.search'|translate }} {{ 'admin.dealer.show.delivery_dealers'|translate }}"
                 [clearable]="false"
                 autofocus
                 [typeahead]="dealersTypeahead">
              <ng-template ng-typetosearch-tmp>
                <div class="ng-option disabled text-black-50">
                  {{ 'global.search'|translate }} {{ 'admin.dealer.show.delivery_dealers'|translate }}
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled text-black-50">
                  {{ 'doctrine.order.no_result_found_for'|translate }} {{ searchTerm }}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="assignDealerModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="assignDealer()">{{'global.actions.save'|translate}}</button>
  </div>
</app-modal-basic>
<ng-template #customerPriceTemp let-row="row" let-value="value" let-column="column">
  {{row.totalCost.totalDealerPrice | BackofficeCurrency}}
</ng-template>

<ng-template #remainingTimeTemp let-row="row" let-value="value" let-column="column">
  <span class="danger" *ngIf="row.remainingDays > 0 && row.remainingDays <= 5">{{row.remainingDays + ' ' + ('global.days' | translate)}}</span>
  <span *ngIf="row.remainingDays > 5">{{row.remainingDays + ' ' + ('global.days' | translate)}}</span>
  <span class="disabled" *ngIf="row.remainingDays <= 0">{{'global.expired' | translate}}</span>
</ng-template>
